/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorButtonActive = "rgb(4, 15, 236)";
export const ColorSurfaceDefault = "rgb(20, 29, 37)";
export const ColorSurfaceReduced = "rgb(36, 45, 53)";
export const ColorSurfaceReducedAlternative = "rgb(25, 35, 43)";
export const ColorSurfaceHovered = "rgb(25, 35, 43)";
export const ColorSurfacePressed = "rgb(36, 45, 53)";
export const ColorSurfacePressedAlternative = "rgb(20, 29, 37)";
export const ColorSurfaceSuccess = "rgb(10, 42, 33)";
export const ColorSurfaceCritical = "rgb(54, 15, 20)";
export const ColorSurfaceContrastDefault = "rgb(235, 236, 236)";
export const ColorSurfaceContrastPressed = "rgb(119, 123, 132)";
export const ColorSurfaceSelectedDefault = "rgb(36, 45, 53)";
export const ColorSurfaceSelectedPressed = "rgb(47, 53, 61)";
export const ColorSurfaceDimmedDefault = "rgba(255, 255, 255, 0.1)";
export const ColorSurfaceOverlayDefault = "rgb(36, 45, 53)";
export const ColorSurfaceOverlayHovered = "rgb(47, 53, 61)";
export const ColorSurfaceOverlayPressed = "rgb(67, 72, 78)";
export const ColorContentDefault = "rgb(235, 236, 236)";
export const ColorContentReduced = "rgb(176, 180, 186)";
export const ColorContentDisabled = "rgb(90, 97, 105)";
export const ColorContentOnActionPrimaryDefault = "rgb(235, 236, 236)";
export const ColorContentOnActionPrimaryDisabled = "rgb(73, 122, 246)";
export const ColorContentOnActionPrimaryDisabledAlternative = "rgb(176, 180, 186)";
export const ColorContentOnActionSecondaryDefault = "rgb(20, 29, 37)";
export const ColorContentOnActionSecondaryDisabled = "rgb(67, 72, 78)";
export const ColorContentOnAccentDefault = "rgb(235, 236, 236)";
export const ColorContentOnContrastCriticalSuccessDefault = "rgb(20, 29, 37)";
export const ColorContentOnContrastCriticalSuccessDefaultAlternative = "rgb(235, 236, 236)";
export const ColorContentOnBackgroundFixedDefault = "rgb(235, 236, 236)";
export const ColorActionPrimaryDefault = "rgb(4, 42, 208)";
export const ColorActionPrimaryDefaultPressed = "rgb(2, 31, 171)";
export const ColorActionPrimaryDefaultDisabled = "rgb(1, 23, 145)";
export const ColorActionPrimaryDisabledAlternative = "rgb(176, 180, 186)";
export const ColorActionPrimaryAlternative = "rgb(73, 122, 246)";
export const ColorActionPrimaryAlternativePressedReduced = "rgb(4, 42, 208)";
export const ColorActionPrimaryAlternativePressed = "rgb(4, 42, 208)";
export const ColorActionPrimaryAlternativeDisabled = "rgb(5, 44, 192)";
export const ColorActionPrimaryDefaultHovered = "rgb(5, 44, 192)";
export const ColorActionPrimaryAlternativeHovered = "rgb(139, 180, 255)";
export const ColorActionSecondaryDefault = "rgb(235, 236, 236)";
export const ColorActionSecondaryDisabled = "rgb(67, 72, 78)";
export const ColorActionSecondaryPressed = "rgb(105, 110, 119)";
export const ColorActionSecondaryPressedReduced = "rgb(36, 45, 53)";
export const ColorActionSecondaryDisabledAlternative = "rgb(36, 45, 53)";
export const ColorActionSecondaryHovered = "rgb(119, 123, 132)";
export const ColorAccentDefault = "rgb(4, 42, 208)";
export const ColorAccentAlternative = "rgb(2, 32, 171)";
export const ColorAccentDisabled = "rgb(2, 31, 171)";
export const ColorInputDefault = "rgb(25, 35, 43)";
export const ColorInputDisabled = "rgb(20, 29, 37)";
export const ColorControlsDefault = "rgb(67, 72, 78)";
export const ColorControlsAlternative = "rgb(115, 119, 120)";
export const ColorControlsDisabled = "rgb(36, 45, 53)";
export const ColorControlsPressed = "rgb(47, 53, 61)";
export const ColorCriticalDefault = "rgb(219, 50, 50)";
export const ColorCriticalPressed = "rgb(138, 52, 55)";
export const ColorCriticalDisabled = "rgb(77, 13, 24)";
export const ColorCriticalAlternative = "rgb(113, 36, 42)";
export const ColorCriticalContrast = "rgb(255, 143, 135)";
export const ColorCriticalHovered = "rgb(180, 70, 70)";
export const ColorCriticalOnContrastDefault = "rgb(203, 29, 36)";
export const ColorSuccessDefault = "rgb(0, 170, 139)";
export const ColorSuccessContrast = "rgb(27, 216, 169)";
export const ColorSuccessAlternative = "rgb(24, 86, 71)";
export const ColorSuccessOnContrastDefault = "rgb(0, 158, 127)";
export const ColorWarningDefault = "rgb(171, 126, 31)";
export const ColorWarningPressed = "rgb(163, 117, 18)";
export const ColorWarningAlternative = "rgb(44, 33, 11)";
export const ColorWarningContrast = "rgb(207, 154, 48)";
export const ColorWarningOnContrastDefault = "rgb(171, 126, 31)";
export const ColorBorderOnActionSecondaryDefault = "rgb(105, 110, 119)";
export const ColorBorderOnActionSecondaryDisabled = "rgb(90, 97, 105)";
export const ColorBorderOnInputDefault = "rgb(67, 72, 78)";
export const ColorBorderOnInputActive = "rgb(105, 110, 119)";
export const ColorBorderOnControlDefault = "rgb(90, 97, 105)";
export const ColorBorderOnControlDisabled = "rgb(67, 72, 78)";
export const ColorBorderOnSelectedDefault = "rgb(90, 97, 105)";
export const ColorBorderOnSelectedDisabled = "rgb(67, 72, 78)";
export const ColorBorderOnSuccessDefault = "rgb(39, 126, 107)";
export const ColorBorderOnCriticalDefault = "rgb(180, 70, 70)";
export const ColorAccessoryDefault = "rgb(90, 97, 105)";
export const ColorAccessoryDefaultAlternative = "rgb(67, 72, 78)";
export const ColorAccessoryReduced = "rgb(36, 45, 53)";
export const ColorAccessoryReducedAlternative = "rgb(36, 45, 53)";
export const ColorAccessoryAlternative = "rgb(184, 138, 45)";
export const ColorAccessoryContrast = "rgb(171, 126, 28)";
export const ColorBackgroundDefault = "rgb(12, 20, 28)";
export const ColorBackgroundAlternative = "rgb(20, 29, 37)";
export const ColorBackgroundDimmedDefault = "rgba(0, 12, 21, 0.9)";
export const ColorBackgroundDimmedReduced = "rgba(0, 12, 21, 0.6)";
export const ColorBackgroundDimmedReducedAlternative = "rgba(0, 12, 21, 0.85)";
export const ColorBackgroundFixedDefault = "rgb(12, 20, 28)";
export const ColorShimmerDefault = "linear-gradient(-90deg, #1f293100 0%, #1f2931 25%, #1f2931 65%, #1f293100 100%)";
export const ColorShadowDefault = "rgba(0, 12, 21, 0.3)";
export const ColorShadowReduced = "rgba(15, 27, 35, 0.2)";
